import React from 'react';

const useMobileInfo = (): [
    boolean | undefined,
    number | undefined,
    number | undefined,
    boolean,
] => {
    const [isMobile, setIsMobile] = React.useState<boolean>();
    const [clientWidth, setClientWidth] = React.useState<number>();
    const [clientHeight, setClientHeight] = React.useState<number>();
    const [isAppleSystem, setIsAppleSystem] = React.useState<boolean>(true);

    const isAppleDevice = () => {
        const userAgent =
            navigator.userAgent || navigator.vendor || (window as any).opera;

        // 判断是否为 iOS（iPhone, iPad, iPod）
        if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
            return true;
        }

        // 判断是否为 macOS
        if (/Macintosh|Mac OS X/.test(userAgent)) {
            return true;
        }

        return false;
    };

    React.useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const width = window.document.body.clientWidth;
        const height = window.document.body.clientWidth;
        const isUsingMobile = width <= 992;
        setIsMobile(isUsingMobile);
        setClientWidth(width);
        setClientHeight(height);
        setIsAppleSystem(isAppleDevice());
        //setIsAppleSystem(false);
    }, []);

    return [isMobile, clientWidth, clientHeight, isAppleSystem];
};

export default useMobileInfo;
